module.exports = __webpack_public_path__ + "static/img/logo.f61010b7.png";